function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './ArticlesFeatureCarousel.css';
import React, { useEffect, useRef, useState } from 'react';
import { canUseDOM, generatrURLFromTags, get, getDictionaryItem, getPageThemeColors, getTags } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { convertToAnalyticObject } from '../../utils/analytics';
import ScrollAnimation from 'react-animate-on-scroll';
import getListing, { generateSeeMoreTagsFromRules, isTagsRule, loadCategoryAlgoliaResults } from '../../utils/getListing';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import ArticlesFeatureCarouselItem from './components/ArticlesFeatureCarouselItem';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import throttle from 'lodash/throttle';
import { useIsVisible } from '../../utils/useIsVisible';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { getTopPicksStorage } from '../atoms/FavouriteBtn/top_picks_apis';
import { idConverter } from '../atoms/FavouriteBtn/FavouriteBtn';
import useMobile from '../../utils/useMobile';
import RouterLink from '../atoms/RouterLink';
const ArticlesFeatureCarousel = _ref => {
  let {
    fields,
    params,
    route
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [isHidden, setIsHidden] = React.useState(false);
  const ref = useRef();
  const isVisible = useIsVisible(ref);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const indexName = get(params, 'SearchIndex');
  const searchCount = Number(get(params, 'SearchCount'));
  const allValues = [];
  const [searchResults, setSearchResults] = useState([]);
  const {
    isPersonalised
  } = sitecoreContext;
  const intents = get(fields, 'data.datasource.intents');
  const intentsLength = get(intents, 'targetItems.length');
  const parentId = get(fields, 'data.contextItem.parent.parentId', '').toLowerCase();
  const contextItem = get(fields, 'data.contextItem');
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  const contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  const datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  const tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  const itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  const isTagsRuleUsed = isTagsRule(tagsRule);
  const typeArticle = 'type:Article';
  const contextItemId = get(fields, 'data.contextItem.id');
  let dummyId;
  if (process.env.STORYBOOK_MODE) {
    dummyId = '6a1d9e4935ad4273804e7cbc56f0d62b';
  }
  const currentPageID = get(route, 'itemId', '').split('-').join('');
  const {
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: searchResults,
    conditions: [algoliaScoredCondition(allValues)]
  });
  const formatTagsRuleToFilters = function () {
    let withType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let facetsFilters = [withType && [typeArticle]];
    if (isTagsRuleUsed) {
      let parsedTR = JSON.parse(tagsRule);
      if (parsedTR.length) {
        parsedTR.forEach(rule => {
          facetsFilters.push(rule);
        });
      }
    }
    return facetsFilters;
  };
  const tagsList = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : considerPageLevelTags ? [...contextItemTags, ...datasourceTags] : [...datasourceTags];
  React.useEffect(() => {
    setSeeMoreURLTags(generatrURLFromTags(tagsList));
    if (isVisible) {
      if (isPersonalised && intentsLength) {
        (async () => {
          const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, typeArticle, searchCount, isTagsRuleUsed ? formatTagsRuleToFilters(false) : considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags], [contextItemId ? `curators.curators.Id:${contextItemId}` : ''], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
          setSearchResults(hits);
          refreshTracking();
        })();
      } else {
        let filters = currentPageID ? `NOT objectID:${currentPageID}` : '';
        if (parentId) {
          filters = currentPageID ? `NOT objectID:${currentPageID} AND NOT objectID:${parentId}` : '';
        }
        let itemFilter = {
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? formatTagsRuleToFilters(true) : [[typeArticle], considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags]],
          filters
        };
        let results = [];
        let hiddenResults = '';
        getListing(indexName, itemFilter, algoliaSettings).then(hits => {
          results.push(hits && hits.hits);
          results[0].map(result => {
            hiddenResults += ` AND NOT objectID:${result.objectID}`;
          });
          if (hits && hits.hits.length !== searchCount) {
            let itemFilter = {
              hitsPerPage: searchCount - hits.hits.length,
              facetFilters: [typeArticle],
              filters: currentPageID ? ` (NOT objectID:${currentPageID} ${hiddenResults})` : ` (NOT objectID:${dummyId} ${hiddenResults})`
            };
            getListing(indexName, itemFilter, algoliaSettings).then(hits => {
              results.push(hits && hits.hits);
              let finalResults = results[0].concat(results[1]);
              finalResults.length ? setIsHidden(false) : setIsHidden(true);
              setSearchResults(finalResults);
            });
          } else {
            results[0].length ? setIsHidden(false) : setIsHidden(true);
            results[0] && setSearchResults(results[0]);
          }
        });
      }
    }
  }, [isPersonalised, isVisible]);
  const carouselWrapperRef = useRef(null);
  const [titleHeight, setTitleHeight] = useState(0);
  const [descHeight, setDescHeight] = useState(0);
  let countHeights;
  const titleEventCheck = get(fields, 'data.datasource.title.jss.value');
  const titleEvent = get(fields, 'data.datasource.title.jss', '');
  const ctaLink = get(fields, 'data.datasource.cTALink.jss.value.href');
  const ctaLabel = get(fields, 'data.datasource.ctaLabel.jss.value');
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const readmore = getDictionaryItem(moduleDictionary, 'ReadMore');
  const greyCards = params !== undefined && params['Is Grey Card'] === '1' ? true : false;
  const ThemeBased = params !== undefined && params['Background Color'] === 'Theme Based' ? true : false;
  const grey = params !== undefined && params['Background Color'] === 'Grey' ? true : false;
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const styleThemeHexColor = ThemeBased ? {
    '--articlesFeatureCarousel-theme-hex-card-background-color': '#fff',
    '--articlesFeatureCarousel-theme-hex-container-background-color': selectedPrimaryColor,
    '--articlesFeatureCarousel-theme-hex-background-color': selectedPrimaryColor,
    '--articlesFeatureCarousel-title-color': 'var(--main-color-text)',
    '--articlesFeatureCarousel-theme-hex-active-color': selectedActiveColor,
    '--articlesFeatureCarousel-dots-color': 'var(--main-color-text)',
    '--articlesFeatureCarousel-arrows-color': 'var(--main-color--active)'
  } : {
    '--articlesFeatureCarousel-theme-hex-card-background-color': greyCards && !grey ? '#f4f4f4' : '#fff',
    '--articlesFeatureCarousel-theme-hex-container-background-color': grey ? '#f4f4f4' : '#fff',
    '--articlesFeatureCarousel-theme-hex-background-color': selectedPrimaryColor,
    '--articlesFeatureCarousel-title-color': '#000',
    '--articlesFeatureCarousel-theme-hex-active-color': selectedActiveColor,
    '--articlesFeatureCarousel-dots-color': '#505050',
    '--articlesFeatureCarousel-arrows-color': 'var(--main-color)'
  };
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (carouselWrapperRef.current && !!searchResults.length) {
        const titleHeights = Array.from(carouselWrapperRef.current.querySelectorAll(`.articlesFeatureCarousel__item-title`)).map(item => {
          return item.offsetHeight;
        });
        const descHeights = Array.from(carouselWrapperRef.current.querySelectorAll(`.articlesFeatureCarousel__text`)).map(item => {
          return item.offsetHeight;
        });
        setTitleHeight(Math.max(...titleHeights));
        setDescHeight(Math.max(...descHeights));
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize, searchResults]);
  const [activeTopPicks, setActiveTopPicks] = React.useState([]);
  const toggleActiveTopPicks = objectId => {
    const id = idConverter(objectId);
    let topPicks = getTopPicksStorage();
    let topPicksList = topPicks.list || [];
    let list = [...topPicksList.map(el => el.itemId)];
    if (list.includes(id)) {
      const index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      }
    } else {
      list.push(id);
    }
    setActiveTopPicks(list);
  };
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      let topPicks = getTopPicksStorage();
      let topPicksList = topPicks.list || [];
      setActiveTopPicks(topPicksList.map(el => el.itemId));
    }
  }, []);
  const isMobile = useMobile(767);
  const mobileList = searchResults.length < 5;
  if (!fields) {
    console.warn('ArticlesFeatureCarousel component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [ArticlesFeatureCarousel component is empty: please provide data source]");
    }
    return null;
  }
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderTileItems = () => {
    return searchResults.map(item => /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.objectID
    }, /*#__PURE__*/React.createElement(ArticlesFeatureCarouselItem, _extends({}, item, {
      readmore: readmore,
      params: params,
      eventsAnalytics: eventsAnalytics,
      toggleActiveTopPicks: id => toggleActiveTopPicks(id),
      activeTopPicks: activeTopPicks,
      mobileList: mobileList
    }))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    styleThemeHexColor: styleThemeHexColor,
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isHidden: true
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    ref: carouselWrapperRef,
    style: {
      '--title-height': titleHeight,
      '--desc-height': descHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12"
  }, isMobile && mobileList ? /*#__PURE__*/React.createElement(React.Fragment, null, titleEventCheck && searchResults.length > 1 ? /*#__PURE__*/React.createElement("div", {
    className: titleEventCheck ? 'articlesFeatureCarousel__title-block' : 'articlesFeatureCarousel__title-block_without-title'
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "articlesFeatureCarousel__title",
    field: titleEvent
  }))) : null, renderTileItems(), ctaLink && ctaLabel && searchResults.length > 1 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: `articlesFeatureCarousel_under-dots btn btn-secondary`,
    href: ctaLink,
    title: `${ctaLabel}`,
    linktype: '',
    linksTarget: '',
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params), [titleEvent.value])
  }, ctaLabel)) : null) : /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: titleEventCheck ? 'articlesFeatureCarousel__title-block' : 'articlesFeatureCarousel__title-block_without-title'
    }, titleEventCheck && searchResults.length > 1 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "articlesFeatureCarousel__title",
      field: titleEvent
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: `btn-group ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['optionsPreviousClickAnalytics'], params)), true, false), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['optionsNextClickAnalytics'], params)), true, false))), renderCarousel(renderTileItems(), {
      responsive: {
        mobile: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "articlesFeatureCarousel_dots_and_cta_wrapper"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['optionsBubblesClickAnalytics'], params))), ctaLink && ctaLabel && searchResults.length > 1 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: "articlesFeatureCarousel_under-dots-wrapper",
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: `articlesFeatureCarousel_under-dots btn btn-secondary`,
      href: ctaLink,
      title: `${ctaLabel}`,
      linktype: '',
      linksTarget: '',
      onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params), [titleEvent.value, ctaLabel])
    }, ctaLabel)) : null));
  })))))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    isHidden,
    anchorUrlParameter,
    styleThemeHexColor
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: styleThemeHexColor
  }, children) : null);
};
export const commonStyles = "c1f5dus1";
const ltrStyles = "l1q5aca7";
const rtlStyles = "r1v5zpkl";
export default ArticlesFeatureCarousel;